import { AppThunkAction } from "../store";
import { KnownAction, FavoriteData, FavoriteEntry } from "../store/favorite";
import * as ActionTypes from "../common/actionTypes";
import * as FavoriteService from "../services/favoriteService";
import { getUserId } from "../adalConfig";

const requestCreate = (favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>): KnownAction => {
    return { type: ActionTypes.RequestCreateFavorite, favoriteEntry };
}

const receiveCreate = (data: FavoriteEntry): KnownAction => {
    return { type: ActionTypes.ReceiveCreateFavorite, data };
}

const requestReadCollection = (): KnownAction => {
    return { type: ActionTypes.RequestReadCollectionFavorite };
};

const receiveReadCollection = (data: FavoriteData): KnownAction => {
    return { type: ActionTypes.ReceiveReadCollectionFavorite, data };
}

const requestDelete = (favoriteEntryId: number): KnownAction => {
    return { type: ActionTypes.RequestDeleteFavorite, favoriteEntryId };
}

const receiveDelete = (): KnownAction => {
    return { type: ActionTypes.ReceiveDeleteFavorite };
}

const handleError = (error: Error): KnownAction => {
    return { type: ActionTypes.HandleErrorFavorite, error };
}

const clear = (): KnownAction => {
    return { type: ActionTypes.ClearErrorFavorite };
}

export const favoriteActionCreators = {
    createFavoriteEntry: (favoriteEntry: Omit<FavoriteEntry, 'favoriteId'>): AppThunkAction<KnownAction> => async (dispatch) => {
        dispatch(clear());
        favoriteEntry.userId = getUserId();
        dispatch(requestCreate(favoriteEntry));
        
        try {
            const response = await FavoriteService.createAsync(favoriteEntry);

            if (!response.ok) {
                throw new Error(response.rawBody);
            }
            
            const createdFavoriteEntry: FavoriteEntry = {
                ...favoriteEntry,
                favoriteId: response.parsedBody
            };
            
            dispatch(receiveCreate(createdFavoriteEntry));
        }
        catch (error) {
            dispatch(handleError(error as Error));
        }
    },
    
    readFavoriteData: (): AppThunkAction<KnownAction> => async dispatch => {
        dispatch(clear());
        dispatch(requestReadCollection());
        
        try {
            const response = await FavoriteService.readCollectionAsync(getUserId());
            if (!response.ok) {
                throw new Error(response.rawBody);
            }

            const favoriteEntries = response.parsedBody;

            const favs = favoriteEntries;
            
            dispatch(receiveReadCollection({ favs }));
        }
        catch (error) {
            dispatch(handleError(error as Error));
        }
    },
    
    deleteFavoriteEntry: (favoriteEntryId: number): AppThunkAction<KnownAction> => async dispatch => {
        dispatch(clear());
        dispatch(requestDelete(favoriteEntryId));

        console.log(favoriteEntryId);
        
        try {
            const response = await FavoriteService.deleteAsync({ favoriteId: favoriteEntryId });
            if (!response.ok) {
                throw new Error(response.rawBody);
            }
            
            dispatch(receiveDelete());
        }
        catch (error) {
            dispatch(handleError(error as Error));
        }
    }
};